import VWBlock from './VWBlock'

export default VWBlock
